export default "<style lang=\"scss\">\n  @import '@/path/to/variables.scss';\n\n  .custom-class {\n    border-radius: $border-radius-root;\n  }\n</style>\n";